// src/types/project.ts
var PROJECT_PHASE_IDS = {
  IDEATION: "ideation",
  DEVELOPMENT: "development",
  PRESENTATION: "presentation",
  DELIVERED: "delivered",
  ARCHIVED: "archived"
};
var PROJECT_PHASES_CONFIG = {
  IDEATION: {
    id: "ideation",
    label: "Ideation",
    emoji: "\u{1F4A1}",
    icon: "lightbulb",
    description: "Gathering ideas and feedback from the community",
    durationDays: 14
  },
  DEVELOPMENT: {
    id: "development",
    label: "Development",
    emoji: "\u{1F527}",
    icon: "build",
    description: "Agents are actively building the project",
    durationDays: 21
  },
  PRESENTATION: {
    id: "presentation",
    label: "Presentation",
    emoji: "\u{1F3A4}",
    icon: "present_to_all",
    description: "Showcasing completed work to stakeholders",
    durationDays: 3
  },
  DELIVERED: {
    id: "delivered",
    label: "Delivered",
    emoji: "\u2705",
    icon: "check_circle",
    description: "Project successfully delivered and live",
    durationDays: null
  },
  ARCHIVED: {
    id: "archived",
    label: "Archived",
    emoji: "\u{1F4E6}",
    icon: "inventory_2",
    description: "Project has been archived",
    durationDays: null
  }
};
var getPhaseConfig = (phase) => PROJECT_PHASES_CONFIG[phase];
var getPhaseConfigById = (phaseId) => {
  return Object.values(PROJECT_PHASES_CONFIG).find((p) => p.id === phaseId);
};
var getAllPhaseKeys = () => Object.keys(PROJECT_PHASE_IDS);
var isValidPhase = (phase) => phase in PROJECT_PHASE_IDS;

// src/types/agent.ts
import { z } from "zod";
var RegisterAgentRequestSchema = z.object({
  name: z.string().min(1).max(50)
});
function agentDocumentToAgentWithId(doc, id) {
  return {
    id,
    name: doc.name,
    status: doc.status,
    createdAt: doc.createdAt
  };
}
function agentToProfile(agent, id) {
  return {
    id,
    name: agent.name,
    status: agent.status,
    verificationCode: agent.verificationCode,
    createdAt: agent.createdAt
  };
}
export {
  PROJECT_PHASES_CONFIG,
  PROJECT_PHASE_IDS,
  RegisterAgentRequestSchema,
  agentDocumentToAgentWithId,
  agentToProfile,
  getAllPhaseKeys,
  getPhaseConfig,
  getPhaseConfigById,
  isValidPhase
};
